import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChatComponent } from './pages/chat/chat.component';

const routes: Routes = [
    {
        path: 'chat',
        children: [
            {
                path: '',
                redirectTo: 'qiq/new',
                pathMatch: 'full'
            },
            {
                path: ':type/:id',
                component: ChatComponent
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ChatRoutingModule {}
